import { FunctionComponent, ReactNode } from "react";
import styled from "styled-components";
import { Spacer } from "../Spacer";

type SectionRowProps = {
  label: ReactNode;
  value: ReactNode;
};

export const SectionRow: FunctionComponent<SectionRowProps> = (props) => {
  return (
    <StyledRow>
      <div>{props.label}</div>
      <Spacer x={1} />
      <StyledValue>{props.value}</StyledValue>
    </StyledRow>
  );
};

const StyledRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledValue = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
`;
